import React, { useState, useEffect } from 'react';
import { Modal, Form, Tooltip } from 'antd';
import { Button, Icon } from '@digital/ui';
import { getSasComentarioOrdemCompra, saveSasComentarioOrdemCompra } from '@app/api/sas/sasDocumentoOrdemCompra';
import ListMensagem from './ListMensagem';
import TextArea from 'antd/lib/input/TextArea';
import { Visibility } from '@app/components';

interface Props {
    documentoId: string
    contemComentario: boolean
    disabled?: boolean
}

const ModalComentarioDocumento = (props: Props) => {
    const { documentoId, contemComentario, disabled = false } = props;
    const [mensagens, setMensagens] = useState([])
    const [exibirModal, setExibirModal] = useState(false);
    const [iconeComentario, setIconeComentario] = useState('');
    const textAreaId = `textAreaId${documentoId}`;

    useEffect(() => {
        if (contemComentario === true) {
            MudarIconeAnexo();
        }
    }, [contemComentario]);

    const MudarIconeAnexo = () => {
        setIconeComentario('has-comments');
    };

    const limparCampo = () => {
        const elemento = document.getElementById(textAreaId);
        if (elemento != null) {
            document.getElementById(textAreaId).value = '';
        }
    };

    const showModal = () => {
        limparCampo();
        setExibirModal(true);
    };

    const handleCancel = () => {
        limparCampo();
        setExibirModal(false);
    };

    const Salvar = (e: any) => {
        const text = document.getElementById(textAreaId).value;
        const form = new FormData();
        form.append('sasDocumentoOrdemCompraId', documentoId);
        form.append('mensagem', text);

        saveSasComentarioOrdemCompra(form).then(data => {
            if (data.valid) {
                limparCampo();
                GetComentarios();
                MudarIconeAnexo();
            }
        });
    };

    const GetComentarios = () => {
        getSasComentarioOrdemCompra(documentoId).then(data => {
            if (data) {
                setMensagens(data)
            }
        })
    }

    return (
        <>
            <Tooltip title="Comentários">
                <Button
                    onClick={() => {
                        GetComentarios()
                        showModal();
                    }}
                    icon="messaging-comments"
                    className={iconeComentario}
                />
            </Tooltip>
            <Visibility
                visible={exibirModal}
            >
                <Modal
                    title="Comentário"
                    className="chat-modal"
                    visible={exibirModal}
                    onCancel={() => {
                        handleCancel();
                    }}
                    footer={[
                        <Button type="link" onClick={() => handleCancel()}>
                            Fechar
                        </Button>,
                        <Visibility visible={disabled === false}>
                            <Button key="submit" type="primary" onClick={e => Salvar(e)}>
                                Enviar
                            </Button>,
                        </Visibility>
                    ]}>
                    {documentoId && <ListMensagem mensagens={mensagens} />}
                    <div className="chat-modal-message-box">
                        <Form>
                            <Form.Item>
                                <TextArea id={textAreaId} placeholder="mensagem" autosize={{ minRows: 3, maxRows: 5 }} maxLength={300} disabled={disabled} />
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
            </Visibility>
        </>
    );
}

export default ModalComentarioDocumento
